<template>
    <div class="popup-item">
        <!-- <div class="reserved" v-show="object.reserved">{{status}}</div> -->
        <Carousel v-if="object.gallery.length && show"
            :perPage="1" 
            :navigationEnabled="true" 
            :paginationActiveColor="'#ffffff'" 
            :paginationColor="'rgba(255,255,255,.4)'"
            :paginationPadding="0"
            :paginationSize="8" >
            <Slide>
                <a data-auto-focus="false" :data-fancybox="object.name" :data-caption="getCaption()" :href="object.thumbnail_large" class="popup-item_image">
                    <div class="reserved" v-show="object.reserved">{{status}}</div>
                    <img :src="object.thumbnail" :alt="object.name">
                </a>
            </Slide>
            <Slide v-for="(image , index) in object.gallery" :key="object.gallery.indexOf(image)">
                <a data-auto-focus="false" :data-caption="getCaption()" :data-fancybox="object.name" :href="object.gallery_large[index]" class="popup-item_image">
                    <div class="reserved" v-show="object.reserved">{{status}}</div>
                    <img :src="image" :alt="object.name">
                </a>
            </Slide>
        </Carousel>
        
        <a data-auto-focus="false" :data-fancybox="object.name" :href="object.thumbnail_large" v-else class="popup-item_image single">
            <img :src="object.thumbnail" :alt="object.name">
        </a>
      
        <div class="popup-item_content">
          
            <div class="popup-item_title">
                <h3><ObjectLink 
                :linkText="object.name" 
                :postId="object.id"
                v-on:set-id="passId" /></h3>
            </div>
           
            <div class="popup-item_price">
                <span class="price">
                    {{Number(object.price).toLocaleString("es-ES", {minimumFractionDigits: 0})}} €
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import ObjectLink from '@/components/ObjectLink'
import { Carousel, Slide } from 'vue-carousel'
export default {
    props: {
        object: {
            type: Object,
            required: true
        },
        show: {
            type: Boolean,
            required: true
        },
        translations: {
            type: Object,
            required: true
        },
        locale: {
            type: String,
            required: true
        },
    },
    components: {
        ObjectLink,
        Carousel, 
        Slide
    },
    data() {
        return {
            status: '',
        }
    },
    methods: {
        passId(data){
            this.$emit('pass-id', data);
        },
        getCaption() {
            let string = this.object.reserved ? `<div class="reserved" >${this.status}</div>` : '';
            return string;
        }
    },
    mounted() {
        this.status = this.translations.reservedItem[this.locale];
    }
}
</script>

<style scoped>
.popup-item {
    width: 18rem;
    position: relative;
    background: #fff;
    overflow: hidden;
    animation: fadein .4s ease-out;
    animation-delay: .4s;
    animation-fill-mode: forwards;
    opacity: 0;
}

.reserved{
    padding: .25rem .5rem;
    font-size: 1rem;
    line-height: 1rem;
    color: #ffffff;
    text-transform: uppercase;
    background-color: #E26E03;
    position: absolute;
    top: 0rem;
    left: 0rem;
    width: 100%;
    text-align: center !important;
    z-index: 2;
}
.VueCarousel {
    width: 100%;
    height: 10rem;
}
.popup-item_image {
    position: relative;
    display: block;
    width: 100%;
    width: 18rem;
    height: 10rem;
}
.popup-item_image::after {
    content: '';
    display: block;
    padding-top: 57%;
}
.popup-item_image img {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.popup-item_title h3 {
    font-stretch: normal;
    font-weight: 400;
    font-size: 1rem;
}
.popup-item_price {
    padding-top: 1rem;
    font-weight: bold;
    white-space: nowrap;
}
.popup-item_content {
    padding: 1rem;
}

@keyframes fadein {
    0% {
        opacity: 0;
        transform: translateY(1rem);
    }
    100% {
        opacity: 1;
        transform: translateY(0);
    }
}
</style>